<template>
  <tr>
    <td>
      <!-- TODO: вынести это в константы -->
      <template v-if="['param', 'symptom'].includes(type.code)">
        <AutocompleteMedParams v-model="form.entity" required return-object :readonly="!editMode" />
      </template>
      <template v-else>
        <v-text-field v-model="form.name" label="Название" required :readonly="!editMode" />
      </template>
    </td>

    <td>
      <PatientDiseasesList return-object v-model="form.diseases" />
    </td>

    <td>
      <div>
        <v-autocomplete
          label="Выберите интервал"
          hide-no-data
          item-text="name"
          return-object
          required
          v-model="form.periodicity"
          :items="periodicityList"
          @change="onChangePeriodicity"
        />
      </div>
    </td>

    <!-- Критичность -->
    <td class="">
      <div class="d-flex justify-center align-center">
        <v-checkbox v-model="form.critical"></v-checkbox>
      </div>
    </td>

    <!-- Ограничить сбор -->
    <td class="">
      <div class="d-flex justify-center align-center">
        <v-checkbox v-model="form.limited"></v-checkbox>
      </div>
    </td>

    <template v-if="form.periodicity && form.periodicity.id === 'on the date'">
      <td colspan="2">
        <input
          type="datetime-local"
          :min="$date().format('YYYY-MM-DD')"
          @keydown.prevent
          @paste.prevent
          @change="updateDatetimeItem($event.target.value)"
        />

        <div v-if="Array.isArray(form.datetimes) && form.datetimes.length">
          <template v-for="(dt, idx) in form.datetimes">
            <div :key="`dt-group-${idx}`" class="d-flex align-items-center mt-1">
              <span class="mr-1">{{ $date(dt).format("DD-MM-YYYY HH:mm") }}</span>

              <v-btn icon x-small text class="ml-1" @click="onRemoveDatetime(dt)">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
            </div>
          </template>
        </div>
      </td>
    </template>
    <template v-else>
      <!-- Начало задания -->
      <td class="">
        <DatePicker v-model="form.startAt" :min="$date().format('YYYY-MM-DD')" />
      </td>

      <!-- Конец задания -->
      <td class="">
        <DatePicker v-model="form.endAt" :min="$date().format('YYYY-MM-DD')" />
      </td>
    </template>

    <!--  -->
    <td class="">
      <div class="d-flex justify-center align-center">
        <v-checkbox v-model="form.lifelong"></v-checkbox>
      </div>
    </td>

    <slot name="after" />
  </tr>
</template>

<script>
import AutocompleteMedParams from "@/components/AutocompleteMedParams.vue";
import PatientDiseasesList from "@/components/PatientDiseasesList.vue";
import DatePicker from "@/components/forms/DatePicker.vue";
import { TasksRepository } from "@/modules/tasks/tasks.repository.js";
import TimePikerDialog from "@/components/forms/TimePikerDialog.vue";

export default {
  name: "TaskItemRow",
  components: { TimePikerDialog, DatePicker, PatientDiseasesList, AutocompleteMedParams },

  props: {
    type: {
      type: Object,
      required: true,
    },
    /** @type {import("vue").PropOptions<TaskScheduledEvent>} */
    form: {
      type: Object,
      required: true,
    },
    editMode: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      /** @type {TaskPeriodicity[]} periodicityList */
      periodicityList: [],
    };
  },

  async created() {
    try {
      const [periodicity] = await Promise.all([TasksRepository.periodicity()]);
      this.periodicityList = periodicity;
    } catch (e) {
      console.error(e);
      this.$dialog.notify.error("Ошибка загрузки справочников");
    }
  },

  methods: {
    onChangePeriodicity() {
      this.form.datetimes = [];
    },

    onRemoveDatetime(dt) {
      this.form.datetimes = this.form.datetimes.filter(item => item !== dt);
    },

    updateDatetimeItem(dateString) {
      this.form.datetimes = [...this.form.datetimes, this.$date(dateString).format("YYYY-MM-DD HH:mm")];
    },
  },
};
</script>

<style scoped></style>
